
import { gsap } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);
export default class ScrolltoTop {
    constructor(container) {
        this.container = container;
        this.scrollcontainer = this.container.getAttribute('data-scroll-container') ? this.container.getAttribute('data-scroll-container') : window;
        this.scrollto = this.container.getAttribute('data-scroll-to') ?? 0;
        this.offsetY = this.container.getAttribute('data-scroll-offset');
        this.duration = this.container.getAttribute('data-scroll-duration') ?? 1.8;
        this.events();
        this.init();
    }
    events = () => {
        this.container.addEventListener('click', this.onClick);
    }
    init = () => {
        gsap.to('.scrollto-top svg .text-group', { rotation: -360, duration: 8, repeat: -1, transformOrigin: '50% 50%', ease: 'none' });
       // gsap.fromTo('.scrollto-top svg .circle', { scale: 0.75, transformOrigin: '50% 50%' }, { scale: 1.05, duration: 1, stagger: { each: 0.2 }, repeat: -1, yoyo: true, transformOrigin: '50% 50%', ease: 'power1.inOut' });
    }

    onClick = (e) => {
        gsap.to(this.scrollcontainer, { duration: this.duration, ease: 'power2.inOut', scrollTo: { y: this.scrollto, offsetY: this.offsetY, autoKill: window.innerWidth > 1024 ? true : false } });
    }
}
